export default "__VITE_ASSET__BqB3XRzI__"